import { ButtonSize } from './Button';

const sizeHierarchy = ['m', 'l', 'xl'];

export const getButtonSize = (size: ButtonSize, hasMobileSize?: boolean) => {
  if (!hasMobileSize) {
    return size;
  }

  if (window.innerWidth > 900) {
    return size;
  }

  const index = sizeHierarchy.indexOf(size);
  if (index !== -1 && index > 0) {
    return sizeHierarchy[index - 1];
  }

  return size;
};
